import React, { useState } from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/HomePage_background.png";
import { useNavigate } from "react-router-dom";

const HomePage = ({ loggedIn }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (loggedIn) {
      navigate("/Services");
    } else {
      navigate("/login");
    }
  };
  return (
    <div className="homeBackgroundDiv">
      <div className="homeContainer">
        <div className="homeContentContainer">
          <h1 className="homeTitleText">
            Compassionate, Respectful, and Affordable care at HOME
          </h1>
          <button onClick={() => handleClick()} className="homeButton">
            {loggedIn
              ? "Let's get started: Book A Service Today"
              : "Let's get started: Register today"}
          </button>
        </div>
        <div className="homeCenterContainer">
          <div className="homeCenterHeader">
            <h1>Support Where You Need It</h1>
          </div>
          <div className="homeCenterBody">
            <div className="homeCenterBodyLeft">
              <p>
                At iCare Village, we believe that aging should be met with
                dignity, care, and a strong sense of belonging. We provide
                non-medical home care services delivered by our care team – care
                aides, nursing students, and retired professionals – who are
                employed by iCare Village and supported through our
                technology-enabled care platform.{" "}
              </p>
              <p>
                Our services are designed to help older adults remain in the
                comfort of their own homes for as long as possible, while
                staying connected, supported, and independent within their
                communities.
              </p>
            </div>
            <div className="homeCenterBodyRight">
              <p>Find Home Care Services Near You</p>
              <div className="homeCenterSearchContainer">
                <input
                  className="homeCenterSearchInput"
                  type="text"
                  placeholder="Enter your postal code or city to view available services in your area."
                ></input>
                <button
                  className="homeCenterSearchButton"
                  onClick={() => {
                    navigate("/Providers");
                  }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
